'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _SpotSearch = require('./SpotSearch');

var _SpotSearch2 = _interopRequireDefault(_SpotSearch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SpotSearch2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/SpotSearch/index.js
// module id = 662
// module chunks = 11